import { Categories, Sections } from '~/graphql/generated'

/**
 * What a category or section starts with when added to a boat: every visible
 * attribute at its default value, and for a section every one of its
 * categories. Built when the row is added, so the form holds the complete
 * structure from the start and saves it as is.
 */
export const defaultCategory = (category: Categories) => ({
  category_id: category.id,
  boat_section_attribute: (category.attributes ?? [])
    .filter((a) => !a.hidden)
    .map((a) => ({ attribute_id: a.id, value: a.default_value })),
})

export const defaultSection = (section: Sections) => ({
  section_id: section.id,
  boat_section_category: (section.categories ?? []).map(defaultCategory),
})
